import { putRequest } from "../httpMethods";


export const putTermForTrainer = (payload, id) =>
    putRequest(`trainerUp/${id}/terms`, payload);